import { render, staticRenderFns } from "./ContentNewView.vue?vue&type=template&id=3c76ac9a&scoped=true"
import script from "./ContentNewView.vue?vue&type=script&lang=js"
export * from "./ContentNewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76ac9a",
  null
  
)

export default component.exports